import React, { useEffect, useState, useContext } from "react";
import moengage from "@moengage/web-sdk";
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
// import { useHistory, useLocation } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import { GetCustomerDetailsContext, validateInputExistenece } from "../../App";
import {
  INIT_UPSELL,
  NEW_APPLICATION,
  SEND_OTP,
  VERIFY_OTP,
} from "../../Config";
import BackButton from "../../assets/svg/EPL_think_svg/BackButton.svg";
import EditIcon from "../../assets/svg/EPL_think_svg/Icon_Edit.svg";
import LoanExpired from "../../assets/svg/EPL_think_svg/loan_expired.svg";
import timer from "../../assets/svg/EPL_think_svg/timer.svg";
import PrivacyPolicy from "../../components/advance/PrivacyPolicy";
import FloatingInput from "../../components/base/FloatingInput.js";
import OTPInput from "../../components/base/OtpInput.js";
import Button from "../../components/core/EPL_Button_Think";
import SubTitle from "../../components/core/SubTitle";
import Title from "../../components/core/Title";
import ShimmerPlaceholder from "../../components/placeholders/ShimmerPlaceholder";
import useMediaQuery from "../../hooks/useMediaQuery";
import { getRouteFromLoanStageService } from "../../shared/services/getRouteFromLoanStageService";
import { isValidMobileNumber } from "../../shared/validations/MobileNumber";
import { isValidOTP } from "../../shared/validations/OTP";
import { encrypt } from "../../utils/crypto";
import sendRequest from "../../utils/sendRequest";
import { AfterLoginLayoutWrapper } from "../_styles/EPL_AfterLoginLayoutWrapper_think";
import { LoginWrapper } from "./_styles/LoginWrapper";
import jwt_decode from "jwt-decode";
import { createLead } from "../../shared/services/crm";
import {
  IncorrectOtpModal,
  MaxOtpRetryModal,
  MaxVerifyOtpRetryModal,
  NoOfferFoundModal,
  OtpExpiredModal,
  ResendOtpModal,
  CheckInternetModal,
  MoveToLoginModal,
  InvalidCaptchaModal,
  ForeclosureExceedRejectModal,
  InvalidURLModal,
  InvalidHashModal
} from "../other-pages/Modals/AllModal";
import CheckField from "../../components/form/CheckField.js";
import { isValidSearchParams } from "../../shared/validations/SearchParams.js";
import { encryptedData } from "../../utils/index.js";
import { userConsentStatus } from "../../utils/userConsentStatus.js";
import sdk from '../../sign3-web-sdk.js';
moengage.initialize({ app_id: "L9SUGRVWTLEJA9UWH2ZEAMHL", cluster: "dc_3" });

const Login = () => {
  // const history = useHistory();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [showInvalidCaptchaModal, setShowInvalidCaptchaModal] = useState(false);
  const navigate = useNavigate();
  const isMobile = useMediaQuery("screen and (max-width: 768px)");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const dsa_hash = searchParams.get("dsa_hash");
  const utm_source = searchParams.get("utm_source");
  const utm_medium = searchParams.get("utm_medium");
  const utm_campaign = searchParams.get("utm_campaign");
  const utm_term = searchParams.get("utm_term");
  const utm_content = searchParams.get("utm_content");
  const inValidNumericEntries = ["e", "-"];
  const [mobNum, setMobNum] = useState("");
  const [moveToLogin, setMoveToLogin] = useState(false);
  const [mobileNumberError, setMobileNumberError] = useState(false);
  const [mobileNumberErrorMessage, setMobileNumberErrorMessage] = useState(
    "Please enter valid mobile number"
  );
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isOtpValid, setIsOtpValid] = useState(false);
  const [isValidNum, setIsValidNum] = useState(false);
  const [enableResendOtp, SetEnableResendOtp] = useState(false);
  const [seconds, setSeconds] = useState();
  const [minutes, setMinutes] = useState();
  const [otp, setOtp] = useState("");
  const [otpDigits, setOtpDigits] = useState(Array(6).fill(""));
  const [resendOtp, setResendOtp] = useState(false);
  const [isOtpwrong, SetIsOtpWrong] = useState(false);
  const [rejectCustomerOnLoad, setRejectCustomerOnLoad] = useState(false);
  // const [customerDetails, setCustomerDetails] = useState(
  //   location?.state?.customerDetails
  // );
  const [customerDetails, setCustomerDetails] = useContext(
    GetCustomerDetailsContext
  );
  const[internetCheck,setInternetCheck] = useState(false);
  const [showShimmer, setShowShimmer] = useState(false);
  const [showMaxRetryModal, setShowMaxRetryModal] = useState(false);
  const [showVerifyMaxRetryModal, setShowVerifyMaxRetryModal] = useState(false);
  const [showNoOfferModal, setShowNoOfferModal] = useState(false);
  const [showOtpExpiredModal, setShowOtpExpiredModal] = useState(false);
  const [showInvalidHashModal, setShowInvalidHashModal] = useState(false);
  const [showInvalidURLModal, setShowInvalidURLModal] = useState(false);
  const source = location.pathname.split("/")[1]; // "epl"

  const [consentCheckbox, setConsentCheckbox] = useState(false);
  const [consentFlag, setConsentFlag] = useState(true);

  const updateConsentCheckbox = () => {
    setConsentCheckbox(!consentCheckbox);
  };

  useEffect(() => {
    if (!(isValidSearchParams() && searchParams.get("dsa_hash"))) {
      setShowInvalidURLModal(true);
    }
  }, []);  

  useEffect(() => {
    const updated = customerDetails;
    updated.source = source;
    setCustomerDetails({
      ...updated,
    });
  }, []);
  
  useEffect(() => { 
    if (
      searchParams.get("token") !== null &&
      searchParams.get("token") !== ""
    ) {
      setShowShimmer(true);
      var decodeToken = jwt_decode(searchParams.get("token"));
      if (decodeToken.sub && decodeToken.is_truncated_journey != true) {
        sessionStorage.setItem("mobileApplication", "TRUE");
      } else {
        sessionStorage.setItem("mobileApplication", "FALSE");
      }
      sessionStorage.setItem("headerToken", searchParams.get("token"));
      if (source === "epl") {
        newApplication(decodeToken.sub);
      } else if (source === "upsell") {
        initUpsell(decodeToken.sub);
      }
    } else {
      sessionStorage.setItem("mobileApplication", "FALSE");
    }
  }, []);

  useEffect(() => {
    if (
      validateInputExistenece(customerDetails) &&
      validateInputExistenece(customerDetails["application_form_number"])
    ) {
      // console.log("Login customerDetails: ", customerDetails);
    }
    if (
      validateInputExistenece(customerDetails) &&
      validateInputExistenece(customerDetails["stage"])
    ) {
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: customerDetails.stage,
      });
      // console.log("stage: ", customerDetails.stage);
      // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
        state: {
          customerDetails: customerDetails,
        },
      });
    } else {
      // console.log("Login Ouch customerDetails ");
    }
  }, [customerDetails]);

  const invokeSign3WebSdk = (mobNum, uuid) => {
    sdk.initialize({
      env: 'PROD', // required: The environment ('PROD', 'STAGE').
      sessionId: uuid, // required: A unique session identifier to track the user session.
      apiKey: process.env.REACT_APP_SIGN3_API_KEY, // required: API key used for authentication (shared separately by Sign3).
      apiSecret: process.env.REACT_APP_SIGN3_API_SECRET, // required: Secret key used for authentication (shared separately by Sign3).
    })
    .then((result) => {
      // alert("sdk initialised")
      // debugger;
      console.log('Initialization successful');
      // debugger;
      result.get({phoneNumber: mobNum})
        .then((response) =>{
          // alert("sign3 get fn invoked")
          // alert(response);
          console.log("response:",response)})
        .catch((error) => console.log('Get error:', error.message));
    }, (error) => {
      console.log('Initialization error:', error.message);
    });
  }

  const getOTP = async () => {
    const rtoken = await executeRecaptcha();
    if (isValidNum) {
      if (!isOtpSent) {
        setShowShimmer(true);
      }
      var payload = {
        mobile_number: mobNum,
        mode: "LOGIN",
      };
      try {
        const formData = new FormData();
        formData.append("data", encryptedData(payload));
        const response = await sendRequest("/" + source + SEND_OTP, formData, "POST", 
        // rtoken
        );
        // console.log("Response: ", response);
        if (response.response.Success) {
          // console.log("Otp sent");
          setShowShimmer(false);
          setIsOtpSent(true);
          setResendOtp(true);
          setMinutes(0);
          setSeconds(60);
          setConsentFlag(false);
        }else{
          if(response.response.Message.ERROR == "reCAPTCHA validation failed"){
            setShowShimmer(false);
            setShowInvalidCaptchaModal(true);
          }
        }
        if (response.response.ErrorType == "OTP_MAX_RETRY") {
          // console.log("Maximum retry reached");
          setShowMaxRetryModal(true);
          setShowShimmer(false);
          setIsOtpSent(true);
          setMinutes(15);
          setSeconds(1);
          setConsentFlag(false);
        }
      } catch (error) {
        if(error.message === "API call cancelled due to connectivity issue"){
          setInternetCheck(true);
        } else{
          console.error(`Unknown Error: Constants Not Retireved - ${error}`);
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "error",
          });
          // // console.log("stage: ", customerDetails.stage);
          // console.log("route: ", route);
          if (searchParams.get("dsa_hash")){
            const url =  `${route}?dsa_hash=${searchParams.get("dsa_hash")}`
            navigate(url, {
              replace: true,
            });
          }
          else{
            const url =  `${route}`
            navigate(url, {
              replace: true,
            });
          }
        }

      }
    }
  };

  const resendOTP = async () => {
    const rtoken = await executeRecaptcha();

    var payload = {
      mobile_number: mobNum,
      mode: "LOGIN",
    };
    try {
      const formData = new FormData();
      formData.append("data", encryptedData(payload));
      setShowShimmer(true);
      setIsOtpSent(false);
      const response = await sendRequest("/" + source + SEND_OTP, formData,"POST", rtoken);
      // console.log("Response: ", response);
      if (response.response.Success) {
        // console.log("Otp sent");
        setShowShimmer(false);
        setIsOtpSent(true);
        setResendOtp(true);
        SetEnableResendOtp(false);
        setMinutes(0);
        setSeconds(60);
        resetOTP();
        setConsentFlag(false);
      }else{
        if(response.response.Message.ERROR == "reCAPTCHA validation failed"){
          setShowShimmer(false);
          setShowInvalidCaptchaModal(true);
        }
      }
      if (response.response.ErrorType == "OTP_MAX_RETRY") {
        // console.log("Maximum retry reached");
        setShowShimmer(false);
        setShowMaxRetryModal(true);
        setIsOtpSent(true);
        SetEnableResendOtp(false);
        setMinutes(15);
        setSeconds(1);
        setConsentFlag(false);
      }
    } catch (error) {
      if(error.message === "API call cancelled due to connectivity issue"){
        setInternetCheck(true);
      }else{
        console.error(`Unknown Error: Constants Not Retireved - ${error}`);
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });
        if (searchParams.get("dsa_hash")){
          const url =  `${route}?dsa_hash=${searchParams.get("dsa_hash")}`
          navigate(url, {
            replace: true,
          });
        } 
        else{
          const url =  `${route}`
          navigate(url, {
            replace: true,
          });
        }
      }

    }
  };

  const verifyOTP = async () => {
    if (isOtpValid) {
      var payload = {
        mobile_number: mobNum,
        otp: otp,
        mode: "LOGIN",
      };
      try {
        setShowShimmer(true);
        const formData = new FormData();
        formData.append("data", encryptedData(payload));
        const response = await sendRequest("/" + source + VERIFY_OTP, formData);
        // console.log("Response: ", response);
        if (response.response.ErrorType == "INVALID_OTP") {
          setShowShimmer(false);
          // console.log("incorrect");
          SetIsOtpWrong(true);
        }
        if (response.response.ErrorType == "OTP_EXPIRED") {
          setShowShimmer(false);
          setShowOtpExpiredModal(true);
        }
        if (response.response.ErrorType === "OTP_MAX_RETRY") {
          setShowShimmer(false);
          setShowVerifyMaxRetryModal(true);
        }    
        if (response.response.Success) {
          // console.log("RES_HEADERS:", response.headers.get('Token'));
          sessionStorage.setItem("headerToken", response.headers.get('Token'))
          sessionStorage.setItem("locationErrorCount", 3);

          sessionStorage.setItem("dsa_hash", searchParams.get("dsa_hash"));
          sessionStorage.setItem("utm_source", searchParams.get("utm_source"));
          sessionStorage.setItem("utm_medium", searchParams.get("utm_medium"));
          sessionStorage.setItem("utm_campaign", searchParams.get("utm_campaign"));
          sessionStorage.setItem("utm_term", searchParams.get("utm_term"));
          sessionStorage.setItem("utm_content", searchParams.get("utm_content"));

          if (source === "epl") {
            await newApplication(mobNum);
          } else if (source === "upsell") {
            await initUpsell();
          }
        }
      } catch (error) {
        if(error.message === "API call cancelled due to connectivity issue"){
          setInternetCheck(true);
        } else{
          console.error(`Unknown Error: Constants Not Retireved - ${error}`);
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "error",
          });
          // // console.log("stage: ", customerDetails.stage);
          // console.log("route: ", route);
          if (searchParams.get("dsa_hash")){
            const url =  `${route}?dsa_hash=${searchParams.get("dsa_hash")}`
            navigate(url, {
              replace: true,
            });
          } 
          else{
            const url =  `${route}`
            navigate(url, {
              replace: true,
            });
          }
        }

      }
    }
  };

  const newApplication = async (mobNum) => {
    var payload = {
      mobile_number: mobNum,
      dsa_hash: searchParams.get("dsa_hash"),
      utm_params: {
        utm_source: searchParams.get("utm_source"),
        utm_medium: searchParams.get("utm_medium"),
        utm_campaign: searchParams.get("utm_campaign"),
        utm_term: searchParams.get("utm_term"),
        utm_content: searchParams.get("utm_content"),
      },
    };
    try {
      const formData = new FormData();
      formData.append("data", encryptedData(payload));
      const response = await sendRequest(
        "/" + source + NEW_APPLICATION,
        formData
      );
      // console.log("Response: ", response);
      if (response.response.Success) {
        invokeSign3WebSdk(response?.response?.Data?.mobile, response?.response?.Data?.uuid);
        if (
          searchParams.get("token") !== null &&
          searchParams.get("token") !== ""
        ) {
          var decodeToken = jwt_decode(searchParams.get("token"));
          if (decodeToken.is_truncated_journey != true){
            sessionStorage.setItem("mobileApplication", "TRUE");
          } else{
            sessionStorage.setItem("mobileApplication", "FALSE");
          }
          sessionStorage.setItem("headerToken", searchParams.get("token"));
        } else {
          sessionStorage.setItem("mobileApplication", "FALSE");
        }
        sessionStorage.setItem("headerToken", response.headers.get("Token"));
        createLead(source, 49, response.response.Data.application_form_number)
        sessionStorage.setItem("eplAuth", "authenticated");
        const pathArray = location.pathname.split('/');
        const endpoint = pathArray[pathArray.length - 1];
        sessionStorage.setItem("URLEndpoint", endpoint);
        sessionStorage.setItem(
          "application_form_no",
          response.response.Data.application_form_number
        );

        // Record the user's consent status using the provided payload and source
        await userConsentStatus({ login_consent: consentCheckbox }, source);

        setCustomerDetails({
          ...customerDetails,
          application_form_number:
            response.response.Data.application_form_number,
          stage: response.response.STAGE,
        });

        setShowShimmer(false);
      } else {
        if (response.response.Message === "Invalid DSA") {
          setShowInvalidHashModal(true);
          setShowShimmer(false);
        }
        else if (response.response.Message === "DSA is None") {
          setShowInvalidHashModal(true);
          setShowShimmer(false);
        }
        else {
          setShowShimmer(false);
        }
      }
    } catch (error) {
      if(error.message === "API call cancelled due to connectivity issue"){
        setInternetCheck(true);
      } else {
        console.error(`Unknown Error: Constants Not Retireved - ${error}`);
        setMoveToLogin(true);
      }
    }
  };
  const initUpsell = async () => {
    var payload = {
      mobile_number: mobNum,
      dsa_hash: searchParams.get("dsa_hash"),
      utm_params: {
        utm_source: searchParams.get("utm_source"),
        utm_medium: searchParams.get("utm_medium"),
        utm_campaign: searchParams.get("utm_campaign"),
        utm_term: searchParams.get("utm_term"),
        utm_content: searchParams.get("utm_content"),
      },
    };
    try {
      const formData = new FormData();
      formData.append("data", encryptedData(payload));
      const response = await sendRequest("/" + source + INIT_UPSELL, formData);
      // console.log("Response: ", response);
      if (response.response.Success) {
        if (
          searchParams.get("token") !== null &&
          searchParams.get("token") !== ""
        ) {
          sessionStorage.setItem("headerToken", searchParams.get("token"));
          sessionStorage.setItem("mobileApplication", "TRUE");
        } else {
          sessionStorage.setItem("mobileApplication", "FALSE");
        }
        createLead(source, 49, response.response.Data.application_form_number)
        // console.log(
        //   "response.response.Data.application_form_number",
        //   response.response.Data.application_form_number
        // );
        if (response.response.is_loan_eligible === false) {
          setRejectCustomerOnLoad(true);
        }
        sessionStorage.setItem("eplAuth", "authenticated");
        sessionStorage.setItem(
          "application_form_no",
          response.response.Data.application_form_number
        );
        // setCustomerDetails({
        //   ...customerDetails,
        //   application_form_number:
        //     response.response.Data.application_form_number,
        //   stage: response.response.STAGE,
        // });
        sessionStorage.setItem("headerToken", response.headers.get("Token"));
        const updated = customerDetails;
        updated.application_form_number =
          response.response.Data.application_form_number;
        updated.stage = response.response.STAGE;
        updated.Data = response.response?.Data;
        updated.source = source;
        setCustomerDetails({
          ...updated,
        });
        const pathArray = location.pathname.split('/');
        const endpoint = pathArray[pathArray.length - 1];
        sessionStorage.setItem("URLEndpoint", endpoint);
        setShowShimmer(false);
      } else {
        setShowNoOfferModal(true);
        setShowShimmer(false);
      }
    } catch (error) {
      if(error.message === "API call cancelled due to connectivity issue"){
        setInternetCheck(true);
      } else {
        console.error(`Unknown Error: Constants Not Retireved - ${error}`);
        setMoveToLogin(true);
      }
    }
  };

  const resetOTP = async () => {
    const newOtpDigits = [...otpDigits];
    for (let i = 0; i < 6; i++) {
      newOtpDigits[i] = "";
    }
    setOtpDigits(newOtpDigits);
  };

  const updateMobileNumber = async (e) => {
    if (e.target.value.length <= 10) {
      // // console.log(e.target.value);
      setMobNum(e.target.value);
      if (isValidMobileNumber(e.target.value)) {
        setCustomerDetails({
          ...customerDetails,
          mobile_number: e.target.value,
        });
        setMobileNumberError(false);
        setIsValidNum(true);
        setMobileNumberError(false);
        setMobileNumberErrorMessage("");
      } else {
        setMobileNumberError(true);
        setMobileNumberErrorMessage("Please enter valid mobile number");
        setIsValidNum(false);
      }
    } else {
    }
  };

  const handleEditClick = () => {
    setIsOtpSent(false);
  };

  /**
   * countdown timer used for resend functionality
   */
  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
          SetEnableResendOtp(true);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  useEffect(() => {
    window.scrollTo(0, 0);
    sessionStorage.clear();
  }, []);

  useEffect(() => {
    var inputBox = document.getElementById("MobileNumber");

    var invalidChars = ["-", "+", "e"];

    inputBox.addEventListener("keydown", function (e) {
      if (invalidChars.includes(e.key)) {
        e.preventDefault();
      }
    });
  }, []);

  useEffect(() => {
    var otpString = otpDigits.join("");
    if (isValidOTP(otpString)) {
      setIsOtpValid(true);
      setOtp(otpString);
    } else {
      setIsOtpValid(false);
    }
  }, [otpDigits]);

  return (
    <>
      <AfterLoginLayoutWrapper width={"100%"}>
        <LoginWrapper className="first-child">
          <ForeclosureExceedRejectModal
            isOpen={rejectCustomerOnLoad}
            onClose={() => {
              setRejectCustomerOnLoad(false);
              var route = getRouteFromLoanStageService({
                source: source,
                stage: "rejected",
              });
              navigate(`${route}`, {
                replace: true,
              });
            }}
          />
          <MoveToLoginModal
            isOpen={moveToLogin}
            onClose={() => {
              setMoveToLogin(false);
              var route = getRouteFromLoanStageService({
                source: customerDetails.source,
                stage: "",
              });
              if (searchParams.get("dsa_hash")) {
                const url = `${route}?dsa_hash=${searchParams.get("dsa_hash")}`;
                navigate(url, {
                  replace: true,
                });
              } else {
                const url = `${route}`;
                navigate(url, {
                  replace: true,
                });
              }
              resetOTP();
              setShowShimmer(false);
            }}
          />
          <InvalidHashModal
            isOpen={showInvalidHashModal}
            modalImage={LoanExpired}
            onClose={() => {
              setConsentFlag(true);
              setShowInvalidHashModal(false);
              setIsValidNum(false);
							setConsentCheckbox(!consentCheckbox);
              resetOTP();
              setMobNum("");
              setIsOtpSent(false);
            }}
          />
          <InvalidURLModal
            isOpen={showInvalidURLModal}
            modalImage={LoanExpired}
            onClose={() => { }}
          />
          <InvalidCaptchaModal
            isOpen={showInvalidCaptchaModal}
            modalImage={LoanExpired}
            onClose={() => {
              setConsentFlag(true);
              setShowInvalidCaptchaModal(false);
              setIsValidNum(false);
							setConsentCheckbox(!consentCheckbox);
              resetOTP();
              setMobNum("");
              setIsOtpSent(false);
            }}
          />
          <OtpExpiredModal
            isOpen={showOtpExpiredModal}
            onClose={() => {
              resendOTP();
              setShowOtpExpiredModal(false);
              resetOTP();
            }}
          />
          <CheckInternetModal
            isOpen={internetCheck}
            onClose={() => {
              setInternetCheck(false);
              setShowShimmer(false);
            }}
          />
          <NoOfferFoundModal
            isOpen={showNoOfferModal}
            modalImage={LoanExpired}
            onClose={() => {
              setShowNoOfferModal(false);
              resetOTP();
              setMobNum("");
              setIsOtpSent(false);
            }}
          />
          <ResendOtpModal
            mobileNumber={mobNum.slice(6, 10)}
            isOpen={resendOtp}
            onClose={() => {
              SetEnableResendOtp(false);
              setResendOtp(false);
              setSeconds(60);
              resetOTP();
            }}
          />
          <IncorrectOtpModal
            isOpen={isOtpwrong}
            onClose={() => {
              SetIsOtpWrong(false);
              resetOTP();
            }}
          />
          <MaxOtpRetryModal
            isOpen={showMaxRetryModal}
            onClose={() => {
              setShowMaxRetryModal(false);
              SetEnableResendOtp(false);
              setResendOtp(false);
              resetOTP();
            }}
          />
          <MaxVerifyOtpRetryModal
						isOpen={showVerifyMaxRetryModal}
						onClose={() => {
							setShowVerifyMaxRetryModal(false);
							setIsOtpSent(false)
							setConsentFlag(true)
							setConsentCheckbox(false)
							setMobNum("")
						}}
					/>
          <div id="login-form">
            <div>
              <div className="heading">
                <img
                  style={{
                    cursor: "pointer",
                    paddingTop: "10px",
                  }}
                  src={BackButton}
                  alt="BackButton.svg"
                  onClick={() => {
                    var route = getRouteFromLoanStageService({
                      source: source,
                      stage: "index",
                    });
                    if (searchParams.get("dsa_hash")){
                      const url =  `${route}?dsa_hash=${searchParams.get("dsa_hash")}`
                      navigate(url, {
                        replace: true,
                      });
                    }
                    else{
                      const url =  `${route}`
                      navigate(url, {
                        replace: true,
                      });
                    }
                  }}
                />
                <Title
                  text={`Let's get to know you`}
                  visible={true}
                  clickable={false}
                />
                <div></div>
              </div>
              <div className="pageSubTitle">
                <SubTitle
                  text={`We need a few details to get you started on your application`}
                  visible={true}
                  clickable={false}
                />
              </div>
            </div>
            <div className="broadLine" />
            {showShimmer ? (
              <>
                <ShimmerPlaceholder
                  height="3em"
                  width="15em"
                  marginTop="2em"
                  visible={showShimmer}
                />
                <ShimmerPlaceholder
                  height="3em"
                  width="22em"
                  marginTop="1em"
                  visible={showShimmer}
                />
                <ShimmerPlaceholder
                  height="2em"
                  width="18em"
                  marginTop="1em"
                  visible={showShimmer}
                />
              </>
            ) : (
              <>
                <div className="heading2">Login/Signup</div>
                <div className="form-input">
                  <FloatingInput
                    label={"Mobile Number"}
                    id="MobileNumber"
                    type="Number"
                    value={mobNum}
                    disabled={isOtpSent}
                    error={mobileNumberError}
                    error_message={mobileNumberErrorMessage}
                    on_change={updateMobileNumber}
                    suffixIcon={
                      isOtpSent ? (
                        <div className="edit-button" onClick={handleEditClick}>
                          <img
                            src={EditIcon}
                            alt="EditIcon.svg"
                            height="20"
                            width="20"
                          />
                          <span style={{ fontSize: "15px", marginLeft: "3px" }}>
                            Edit
                          </span>
                        </div>
                      ) : null
                    }
                  />
                  {consentFlag ? (
                      <>
                        <CheckField
                          id="basic-ckeckfield"
                          checked={consentCheckbox}
                          label={
                            <>
                              By proceeding, you agree to Aditya Birla Capital Limited's&nbsp;&nbsp;
                              <a
                                href="https://finance.adityabirlacapital.com/privacy-policy"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ backgroundColor: "none", color: "#0074CC", textDecoration: "underline" }}
                              >
                                privacy policy
                              </a>
                              &nbsp;and&nbsp;
                              <a
                                href="https://finance.adityabirlacapital.com/terms-and-conditions"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ backgroundColor: "none", color: "#0074CC", textDecoration: "underline" }}
                              >
                                terms and conditions.
                              </a>
                              <p>Mobile number provided is linked with my Aadhaar Number.</p>
                            </>
                          }
                          style={{
                            fontSize: "1.4rem",
                            marginTop: "28px",
                          }}
                          onClick={updateConsentCheckbox}
                        />
                      </>
                  ) : (
                    <></>
                  )}
                </div>
                <div className="display-message">
                  {isOtpSent
                    ? "OTP has been sent on mobile number"
                    : "You will receive OTP on mobile number"}
                </div>
              </>
            )}

            {showShimmer ? (
              <>
                <ShimmerPlaceholder
                  height="3em"
                  width="10em"
                  marginTop="2em"
                  visible={showShimmer}
                />
                <ShimmerPlaceholder
                  height="3em"
                  width="20em"
                  marginTop="1em"
                  visible={showShimmer}
                />
                <ShimmerPlaceholder
                  height="2em"
                  width="12em"
                  marginTop="0.5em"
                  visible={showShimmer}
                />
                <ShimmerPlaceholder
                  height="3em"
                  width="9em"
                  marginTop="1em"
                  marginBottom="1em"
                  visible={showShimmer}
                />
              </>
            ) : (
              <>
                {isOtpSent ? (
                  <>
                    <div className="heading2">Enter OTP</div>
                    <div className="otp-box">
                      <div>
                        <OTPInput
                          length={6}
                          otpDigits={otpDigits}
                          setOtpDigits={setOtpDigits}
                        />
                      </div>
                    </div>
                    <div className="resnd-otp-row">
                      <div className="resend-otp">
                        {enableResendOtp ? (
                          <></>
                        ) : (
                          <>
                            <img className="timer-img" src={timer} />
                          </>
                        )}
                        <button
                          disabled={!enableResendOtp}
                          style={{
                            border: "None",
                            backgroundColor: "transparent",
                            color: enableResendOtp ? "#3C94FC" : "grey",
                            marginRight: "5px",
                          }}
                          onClick={async () => {
                            await resendOTP();
                            // console.log("resend OTP clicked");
                          }}
                        >
                          Re-send OTP
                        </button>
                      </div>
                      {enableResendOtp ? (
                        <></>
                      ) : (
                        <>
                          <div>
                            in {minutes < 10 ? `0${minutes}` : minutes}:
                            {seconds < 10 ? `0${seconds}` : seconds}
                            {/* in 00:
                            {seconds < 10 ? `0${seconds}` : seconds} */}
                          </div>
                        </>
                      )}
                    </div>
                    <Button
                      id="VerifyOTP"
                      className="Btn VerifyOTP"
                      disabled={!isOtpValid}
                      mobile={isMobile}
                      onClick={verifyOTP}
                      text={"Verify"}
                    />
                  </>
                ) : (
                  <>
                    {showShimmer ? (
                      <></>
                    ) : (
                      <>
                        <Button
                          id="GetOTP"
                          className="Btn GetOTP"
                          // disabled={!isValidNum}
                          disabled={!(isValidNum && consentCheckbox)}
                          mobile={isMobile}
                          onClick={getOTP}
                          text={"Get OTP"}
                        />
                      </>
                    )}
                  </>
                )}
              </>
            )}
          </div>
          <div className="bottomDiv">
            <div className="features-box">
              <div className="features-box-heading">Key Features</div>
              <div className="features-box-content">
                &#x2022;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Flexible EMI and Tenure
              </div>
              <div className="features-box-content">
                &#x2022;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Low interest rates
                starting from 10.99% p.a.
              </div>
              <div className="features-box-content">
                &#x2022;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Easy Loan servicing
                through Aditya Birla Capital Limited mobile app
              </div>
            </div>
            {/* <div className="privacy-policy">
              <PrivacyPolicy />
            </div> */}
          </div>
        </LoginWrapper>
      </AfterLoginLayoutWrapper>
    </>
  );
};

export default Login;
